import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { UTILS } from "utils";
import AppOutlineButton from "components/ui/AppOutlineButton";
import {useSendOrderToJeeblyMutation} from "redux/Logistic/JeeblyService";
import { LoaderAction } from "redux/actions";
import { ifnullOrUndefined } from "utils/Utils";
import { errorHandler } from "api/api/errorHandler";

const CreateClaim = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const [sendOrderToJeebly] = useSendOrderToJeeblyMutation();
  

  const sendOrderToJeeblyFunc = async () => {
    try {
      if (!orderInfo?._id) return;
      dispatch(LoaderAction.setLoading(true));
      const result = await sendOrderToJeebly({
        orderId: orderInfo._id,
      });
      if (result?.data?.success === 1) {
        UTILS.successNotification(t(result?.data?.message));
      } else {
        UTILS.errorNotification(t(result?.error?.data));
      }
      await props.fetchOrderDetailsByID();
    } catch (error) {
      UTILS.handleErrorNotification(errorHandler(error?.error));
    }
    new Promise((resolve) => setTimeout(resolve, 3000));
    dispatch(LoaderAction.setLoading(false));
  };

  const allowSendOrderToJeebly = () => {
    if (
      ifnullOrUndefined(
        orderInfo?.logisticPartnerMetadata?.JEEBLY?.createDeliveryResponse
          ?.['Order Id']
      ) ||
      orderInfo?.logisticPartnerMetadata?.JEEBLY?.deliveryStatus ===
        "CANCELED"
    ) {
      return true;
    }
    return false;
  };

  return (
    <Fragment key={props?.customKey}>
      <div className="w-full min-h-[100px] py-2">
        {allowSendOrderToJeebly() ? (
          <div className="flex justify-center items-center">
            <AppOutlineButton
              variant="secondary"
              size="lg"
              onClick={sendOrderToJeeblyFunc}
            >
              {t("Send order to Jeebly")}
            </AppOutlineButton>
          </div>
        ) : (
          <div className="flex items-center justify-center text-center px-2 py-4">
            <span className="text-sm text-gray-500">
              {t(
                "Your order has been sent to Jeebly for delivery. Please check the ORDER DETAIL tab for Rider details"
              )}
            </span>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CreateClaim;
